// extracted by mini-css-extract-plugin
export var link = "Contact-module--link--3JySE";
export var text = "Contact-module--text--1BvDg";
export var img = "Contact-module--img--1ta2A";